import { DNVReportStatus } from '../../../enums/dnvReportStatusEnum';
import { StatusText } from './VerificationIcon.styles';
import { getProcessStatusString } from '../../../utils/verification/verificationUtils';

export const VerificationStatusText = (status: DNVReportStatus) => {
    switch (status) {
        case DNVReportStatus.VoyageOngoing:
            return (
                <StatusText className="status-text status-ongoing-voyage">
                    <span className="status-icon"></span>
                    <span className="status-label">{getProcessStatusString(status)}</span>
                </StatusText>
            );
        case DNVReportStatus.InternalControlIssues:
            return (
                <StatusText className="status-text status-internal-issues">
                    <span className="status-icon"></span>
                    <span className="status-label">{getProcessStatusString(status)}</span>
                </StatusText>
            );
        case DNVReportStatus.ReadyForVerification:
            return (
                <StatusText className="status-text status-ready-for-verification">
                    <span className="status-icon"></span>
                    <span className="status-label">{getProcessStatusString(status)}</span>
                </StatusText>
            );
        case DNVReportStatus.SentToDNV:
            return (
                <StatusText className="status-text status-sent">
                    <span className="status-icon"></span>
                    <span className="status-label">{getProcessStatusString(status)}</span>
                </StatusText>
            );
        case DNVReportStatus.VerifiedByDNV:
            return (
                <StatusText className="status-text status-verified">
                    <span className="status-icon"></span>
                    <span className="status-label">{getProcessStatusString(status)}</span>
                </StatusText>
            );
        case DNVReportStatus.DNVIssues:
            return (
                <StatusText title="Issues reported by DNV" className="status-text status-issues">
                    <span className="status-icon"></span>
                    <span className="status-label">{getProcessStatusString(status)}</span>
                </StatusText>
            );
        case DNVReportStatus.NewVersionAvailable:
            return (
                <StatusText title="A new version of the report is available and ready to be sent to DNV." className="status-text status-new-version">
                    <span className="status-icon"></span>
                    <span className="status-label">{getProcessStatusString(status)}</span>
                </StatusText>
            );
    }
};

export default VerificationStatusText;
